export default __webpack_public_path__ + "static/media/chuvas.43f0d6c1.svg";